import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trip-advisor',
  templateUrl: './trip-advisor.component.html',
  styleUrls: ['./trip-advisor.component.css']
})
export class TripAdvisorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/header/trip-advisor/trip-advisor.component.ts